if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.handleCTAClick = this.handleCTAClick.bind(this);
      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
    }

    connectedCallback() {
      this.performRecommendations();
    }

    disconnectedCallback() {
      const ctas = this.querySelectorAll('.product-card__add-to-cart--button');
      ctas.forEach(cta => {
        cta.removeEventListener('click', this.handleCTAClick);
      });
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (recommendations){
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const recommendationsHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('[data-recommendations]')?.innerHTML;
            if (!recommendationsHTML) return;
            this.classList.remove('hidden');
            var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
            if (cartDrawerItemsFull) {
              cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
            }
            recommendations.innerHTML = recommendationsHTML;
            this.initSlider();
            this.attachCTAListeners();
            // initiate quick cart after fetch
            // to activate trigger button events
            setTimeout(() => {
              if (document.querySelector("quick-cart-drawer")) {
                document.querySelector("quick-cart-drawer").init();
              }
            }, 500);
          });
      } else{
        this.initSlider();
        this.attachCTAListeners();
      }
    }

    attachCTAListeners() {
      const ctas = this.querySelectorAll('.product-card__add-to-cart--button');
      ctas.forEach(cta => {
        cta.addEventListener('click', this.handleCTAClick);
      });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
        navigation: {
          nextEl: this.querySelector('.swiper-button--next'),
          prevEl: this.querySelector('.swiper-button--prev'),
        },
      });
    }

    handleCTAClick(event) {
      const button = event.currentTarget;
      const loadingSpinner = button.querySelector('.quick-cart-drawer__trigger--loading');

      if (loadingSpinner) {
        loadingSpinner.style.display = 'block';
        button.querySelector('span').style.display = 'none';
      }

      const variantId = button.dataset.productId;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ 
          id: variantId,
          quantity: 1,
          sections: this.cart ? this.cart.getSectionsToRender().map(section => section.section) : [],
          sections_url: window.location.pathname
         }),
        
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          if (this.cart) {
            this.cart.renderContents(data);
          }
          if (loadingSpinner) {
            loadingSpinner.style.display = 'none';
            button.querySelector('span').style.display = 'block';
          } else {
            button.querySelector('span').style.display = 'block';
          } 
        })
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
